import { STATIC_ASSETS_CLOUDFRONT_URL } from "app/constants"
import { CoverSectionProps } from "./types"

const CoverSection = ({
  location,
  title,
  subtitle,
  coverImage,
  locationColor,
  titleColor,
  titleLength = "short",
}: CoverSectionProps) => (
  <section
    style={{
      backgroundColor: "#000000",
      color: "#FFFFFF",
    }}
  >
    <div className="grid h-screen grid-cols-1 lg:h-screen lg:grid-cols-2">
      <div className="m-auto h-[50vh] w-4/5 flex-row content-center pl-0 text-left lg:h-screen lg:pl-12 xl:w-3/4">
        <div className="-ml-2 flex h-[10%] flex-row">
          <img
            src={`${STATIC_ASSETS_CLOUDFRONT_URL}/AF-Logo-Knockout-LtGreen-Horiz.png`}
            className="-mt-2 mr-2 inline h-8 md:mt-0 lg:h-10 xl:h-16"
            alt="American Forest Logo"
          />
          <img
            src={`${STATIC_ASSETS_CLOUDFRONT_URL}/stories/LCILogo.svg`}
            className="-mt-2 inline h-6 pt-2 md:mt-0 lg:h-8 xl:h-12 xl:pt-4"
            alt="LCI Logo"
          />
        </div>
        <div className="h-[70%] content-center">
          <div
            className={`text-xs font-bold tracking-wider lg:text-base xl:text-xl text-[${locationColor}]`}
          >
            {location}
          </div>
          <div>
            <p
              id="shade-start"
              className={`${titleColor} ${
                titleLength === "long"
                  ? "2xl:leading-12 text-2xl leading-6 lg:text-3xl lg:leading-8 xl:text-4xl xl:leading-9 2xl:text-5xl"
                  : "md:leading-11 xl:leading-11 2xl:leading-11 text-2xl leading-6 sm:text-3xl sm:leading-7 md:text-5xl xl:text-6xl 2xl:text-7xl"
              } pt-0 font-bold tracking-wide lg:pt-2`}
            >
              {title}
            </p>
            <div className="pr-0 pt-1 text-[0.82rem] leading-4 md:text-sm md:leading-4 lg:pr-12 lg:pt-4 lg:text-lg lg:leading-5 xl:text-xl xl:leading-6">
              {subtitle}
            </div>
          </div>
        </div>
        <div className="mt-1 flex items-center md:mt-0">
          <div className="pb-1 pr-4 text-xs font-bold tracking-wider lg:text-sm xl:text-base">
            SCROLL TO READ
          </div>
          <div className="animate-bounce">
            <img
              src={`${STATIC_ASSETS_CLOUDFRONT_URL}/icons/down-caret.svg`}
              className="h-2.5 md:h-3.5"
            />
          </div>
        </div>
      </div>
      <div>
        <img
          src={`${STATIC_ASSETS_CLOUDFRONT_URL}/stories/${coverImage}`}
          className="h-[50vh] w-full object-cover object-center lg:h-screen"
        />
      </div>
    </div>
  </section>
)

export default CoverSection
